import React from "react";
import { Table, Tag } from "antd";

export default function AppointmentTab() {
    // Dữ liệu danh sách lịch hẹn chuẩn theo hình mẫu
    const dataSource = [
        {
            key: "1",
            time: "20/12/2025 10:00",
            type: "Thực hiện K·Reskin",
            branch: "Trần Hưng Đạo Q1",
            status: "Đã đến",
        },
        {
            key: "2",
            time: "27/12/2025 10:00",
            type: "Tái khám 7 ngày",
            branch: "Trần Hưng Đạo Q1",
            status: "Khách dời → 03/01",
        },
        {
            key: "3",
            time: "03/01/2026 10:00",
            type: "Tái khám",
            branch: "Trần Hưng Đạo Q1",
            status: "Đã đến",
        },
        {
            key: "4",
            time: "18/12/2026 10:00",
            type: "Khám + K·Lift buổi 1 (giữ chỗ)",
            branch: "Trần Hưng Đạo Q1",
            status: "Chờ cọc",
        },
    ];

    const columns = [
        {
            title: "Thời gian",
            dataIndex: "time",
            key: "time",
            width: "25%",
            render: (text: string) => <span className="font-medium text-gray-800 dark:text-gray-200">{text}</span>
        },
        {
            title: "Loại",
            dataIndex: "type",
            key: "type",
            width: "35%",
            render: (text: string) => <span className="font-medium text-gray-900 dark:text-gray-100">{text}</span>
        },
        {
            title: "Chi nhánh",
            dataIndex: "branch",
            key: "branch",
            width: "22%",
            render: (text: string) => <span className="text-gray-700 dark:text-gray-300">{text}</span>
        },
        {
            title: "Trạng thái",
            dataIndex: "status",
            key: "status",
            width: "18%",
            render: (status: string) => {
                let colorClass = "text-gray-700";
                if (status === "Đã đến") colorClass = "text-green-700 font-medium dark:text-green-400";
                if (status.includes("Khách dời")) colorClass = "text-amber-700 font-medium dark:text-amber-400";
                if (status === "Chờ cọc") colorClass = "text-blue-700 font-medium dark:text-blue-400";

                return <span className={colorClass}>{status}</span>;
            }
        },
    ];

    return (
        <div className="space-y-3 pt-1 animate-fade-in text-xs">
            {/* Bảng danh sách lịch hẹn */}
            <div className="border border-[#3E91AB]/30 rounded overflow-hidden">
                <Table
                    dataSource={dataSource}
                    columns={columns}
                    pagination={false}
                    size="small"
                    className="custom-appointment-table"
                    scroll={{ x: "max-content" }}
                    rowClassName={(record, index) => 
                        index % 2 === 1 
                            ? "bg-slate-50/80 dark:bg-[#252525]" 
                            : "bg-white dark:bg-[#1f1f1f]"
                    }
                />
            </div>

            {/* Thông tin tổng kết bên dưới bảng */}
            <div className="text-xs text-gray-700 dark:text-gray-300 space-y-1 pt-1 font-medium">
                <div className="flex gap-4">
                    <span className="w-28 text-gray-500">Số lần không đến</span>
                    <span className="font-bold">0</span>
                </div>
                <div className="flex gap-4">
                    <span className="w-28 text-gray-500">Số lịch</span>
                    <span className="font-bold">4</span>
                </div>
            </div>
        </div>
    );
}